// Shared tone options for both the Regenerate Posts dialog (Researched Posts)
// and the Prompt Posts tab. Keep in sync with backend TONE_LIBRARY keys.

export const TONE_OPTIONS = [
  { key: 'conversational', label: 'Conversational', hint: 'Talk like over coffee' },
  { key: 'friendly', label: 'Friendly', hint: 'Warm and encouraging' },
  { key: 'corporate', label: 'Corporate', hint: 'Polished, board-ready' },
  { key: 'analytical', label: 'Analytical', hint: 'Data-first, framework-led' },
  { key: 'contrarian', label: 'Contrarian', hint: 'Challenge the consensus' },
  { key: 'connector', label: 'Connector', hint: 'Bridge 2 diverse ideas' },
  { key: 'storytelling', label: 'Storytelling', hint: 'Open with a micro-story' },
];
